module.exports = __webpack_public_path__ + "img/23.8d570bd9.jpg";